import styled from 'styled-components';
import Button from '@prisjakt/ui-button';

import { media } from '@prisjakt/ui-base';

const chipStyle = {
  width: 'auto',
  borderRadius: '20px',
  padding: '2px 5px 2px 10px',
};

export const ToggleVisibilityButton = styled(Button)(
  {
    width: '100%',
  },
  media.largeUp(chipStyle),
  props =>
    props.chip === true && {
      width: 'auto',
      borderRadius: '20px',
      padding: '2px 5px 2px 10px',
    }
);
